// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ehck","footer":"styles_footer__2wYb1"};